import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/productos/")({
  beforeLoad: () => {
    throw redirect({ to: "/productos/catalogo" });
  },
});
